<ion-content class="ion-padding ion-text-center">
  <div class="not-found-container">
    <div class="image-wrapper">
      <img src="https://niwiai-profile.s3.ap-south-1.amazonaws.com/prim-mobile-app/404.svg" alt="404 Not Found" class="error-img">
    </div>
    <div class="content-wrapper">
      <h1 class="error-title">Oops!</h1>
      <h3 class="error-subtitle">Page Not Found</h3>
      <p class="error-description">
        The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.
      </p>
      <div class="button-wrapper">
        <ion-button (click)="goHome()" color="primary" shape="round">
          Go Back Home
        </ion-button>
      </div>
    </div>
  </div>
</ion-content>
